import { api } from '@/store/interfaces/apiCraft'
import Vue from 'vue'

import data from '@/assets/data/data'

export default {
  namespaced: true,

  state: {
    loaded: false,
    title: data.title,
    vimeo: data.vimeo,
    youtube: data.youtube,
    video: data.video,
    questions: data.questions,
    answeredQuestion: 0,
    totalQuestion: 0,
    score: 0
  },

  getters: {
    title: state => {
      return state.title
    },
    vimeo: state => {
      return state.vimeo
    },
    youtube: state => {
      return state.youtube
    },
    video: state => {
      return state.video
    },
    questions: state => {
      return state.questions
    },
    loaded: state => {
      return state.loaded
    },
    timeline: state => {
      return state.questions.map((question, index) => {
        return {
          "timecode": question.timecode,
          "event": "question:strat",
          "options": index,
          "children": [{
            "event": "question:end",
            "timecode": question.timecode + question.duration
          }]
        }
      })
    },
    answeredQuestion: state => {
      return state.answeredQuestion
    },
    totalQuestion: state => {
      return state.totalQuestion
    },
    score: state => {
      return state.score
    }
  },

  actions: {
    // entry ({ commit, state }, slug) {
    //   const { request, cache } = api.getEntry(slug)
    //   cache.then(res => {
    //     if (res !== null) {
    //       commit('entry', res)
    //       commit('loaded', true)
    //     }
    //   })

    //   request.then(res => {
    //     commit('entry', res)
    //     commit('loaded', true)
    //   })
    // },
  },

  mutations: {
    loaded (state, payload) {
      state.loaded = payload
    },

    questions (state) {
      state.questions.forEach(question => {
        question.timecode = formatTimecode(question.timecode)
        question.duration = formatTimecode(question.duration)
      })

      state.loaded = true
      state.totalQuestion = state.questions.length
    },

    // totalQuestion (state, payload) {

    // },

    incrementScore (state, payload) {
      state.score += payload

      state.answeredQuestion += 1
    }

    // entry (state, payload) {
    //   state.entry = payload

    //   state.entry.avObject.forEach(object => {
    //     // TIME APPEARANCE
    //     let time = object.timeAppearance.split(':')
    //     if (time.length !== 2) {
    //       object.timeAppearance = ''
    //     }
    //     else {
    //       object.timeAppearance = parseFloat(time[0]) * 60 + parseFloat(time[1])
    //     }
    //     // TIME DISAPPEARANCE
    //     time = object.timeDisappearance.split(':')
    //     if (time.length !== 2) {
    //       object.timeDisappearance = ''
    //     }
    //     else {
    //       object.timeDisappearance = parseFloat(time[0]) * 60 + parseFloat(time[1])
    //     }
    //   })
    // }
  }
}

function formatTimecode (time) {
  time = time.split(':')
  if (time.length !== 2) {
    return object.timeAppearance = ''
  }

  return parseFloat(time[0]) * 60 + parseFloat(time[1])
}